import { useEffect, useState } from 'react'
import { elector } from 'src/util/broadcast-channel'

import LogRocket from 'logrocket'
import { useHistory, useLocation } from 'react-router-dom'
import { QUOTE_RECOVERY_KEY } from 'src/components/common/EditableQuote/quoteRecovery'

export default function CheckQuoteRecovery(): JSX.Element {
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    let current = true
    // only check for unsaved quote if this is the "leader" tab
    // (or wait until it becomes the leader, then check)
    elector.awaitLeadership().then(() => {
      // this timeout is really hacky :|. The clearing of recovery data when in EditableQuote
      // happens on a setTimeout(fn, 0) so it can check for an error from the error boundary (which happens after unmount).
      // So we need to make sure this recovery check happens _after_ that one otherwise
      // it will run before it's cleared from EditableQuote's unmount.
      setTimeout(() => {
        if (current) {
          const quoteRecoveryKeys = Object.keys(localStorage).filter((key) => key.startsWith(QUOTE_RECOVERY_KEY))

          const isQuoteEditRoute = /\/(?:quotes|invoices)\/(?:new|edit)/.test(location.pathname)

          if (quoteRecoveryKeys.length > 0) {
            const recoveryData = JSON.parse(localStorage.getItem(quoteRecoveryKeys[0]))
            const label = recoveryData.quote.is_invoice ? 'invoices' : 'quotes'

            LogRocket.info(
              'Quote Recoveries Found',
              JSON.stringify(
                quoteRecoveryKeys.reduce(
                  (all, key) => ({
                    ...all,
                    [key]: JSON.parse(localStorage.getItem(key))
                  }),
                  {}
                )
              )
            )

            if (!isQuoteEditRoute) {
              if (recoveryData.isNew) {
                history.push(`/${label}/new`, {
                  recoveryData
                })
              } else {
                history.push(`/${label}/edit/${recoveryData.quote._id}`, {
                  recoveryData
                })
              }
            }
          }
        }
      }, 100)
    })
    return () => {
      // we create a new awaitLeadership listener when we change routes, so we need to invalidate the old ones
      current = false
    }
  }, [location.key])

  // temporary to help recover "lost" offline quotes
  const [lastUnsavedLog, setLastUnsavedLog] = useState(0)
  useEffect(() => {
    if (lastUnsavedLog < Date.now() - 1000 * 60 * 2) {
      const quoteLog = JSON.parse(localStorage.getItem('quoteLog') || '{}')

      if (Object.keys(quoteLog).length) {
        console.log('Quote Log')
        console.log(quoteLog)
      }
      setLastUnsavedLog(Date.now())
    }
  }, [lastUnsavedLog, location])

  return null
}
